import * as React from "react";
import {useCallback} from "react";
import {
    classNames,
    layout,
    LockStatusBadge,
    MaterialIcon,
    PushButton,
    typography,
    useBoxLockStatus,
    usePlatform,
    View,
    ViewContent,
    ViewFooter,
    ViewFooterItem,
    ViewHeader,
    ViewHeaderItem
} from "@variocube/cube-ui";
import {Box} from "@variocube/app-api";
import {stylesheet} from "typestyle";
import {useLocalization} from "../../i18n";

export interface BoxViewProps {
    box: Box;
    onBack: () => void;
}

export function BoxView({box, onBack}: BoxViewProps) {
    const {t} = useLocalization();

    const lockStatus = useBoxLockStatus(box.number);

    const platform = usePlatform();
    const handleOpen = useCallback(async () => {
        await platform.openBoxLock(box.number);
    }, [platform, box]);

    return (
        <View>
            <ViewHeader>
                <ViewHeaderItem fill className={layout.paddingMedium}>
                    <div className={typography.title}>{t("Box")} {box.number}</div>
                    <div className={typography.description}>{box.types.join(", ")}</div>
                </ViewHeaderItem>
                <ViewHeaderItem className={layout.paddingMedium}>
                    {lockStatus && (
                        <LockStatusBadge lockStatus={lockStatus} strings={t}/>
                    )}
                </ViewHeaderItem>
                <ViewHeaderItem className={layout.paddingMedium}>
                    <PushButton onClick={handleOpen}>
                        {t("OpenBox")}
                    </PushButton>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={layout.horizontal}>

            </ViewContent>
            <ViewFooter className={classNames(layout.paddingMedium, layout.spaceBetween)}>
                <ViewFooterItem>
                    <PushButton onClick={onBack} icon={MaterialIcon.arrow_back}>
                        {t("Back")}
                    </PushButton>
                </ViewFooterItem>
            </ViewFooter>
        </View>
    )
}

const styles = stylesheet({
    halfWidth: {
        width: "50%"
    }
})